import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateCMapMetadata = ({
  Show,
  Hide,
  Title,
  getStudyCDISCCMap,
  cMapData,
  studyId,
}) => {
  const [codeListName, setCodeListName] = useState("");
  const [source, setSource] = useState("");
  const [target, setTarget] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (cMapData) {
      setCodeListName(cMapData?.codeListName || "");
      setSource(cMapData?.source || "");
      setTarget(cMapData?.target || "");
    }
  }, [cMapData]);

  const updateStudyCDISCCMap = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this cmap?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = cMapData?._id;
        userData.codeListName = codeListName;
        userData.source = source;
        userData.target = target;
        userData.studyId = studyId;
        let data = await cdiscManagementService.updateStudyCDISCCMap(userData);
        if (data?.statusCode === 200) {
          getStudyCDISCCMap();
          Hide();
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            CodeList Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={codeListName}
            onChange={(e) => setCodeListName(e.target.value)}
            placeholder="Enter CodeList Name"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Source</Form.Label>
          <Form.Control
            type="text"
            value={source}
            onChange={(e) => setSource(e.target.value)}
            placeholder="Enter source "
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Target</Form.Label>
          <Form.Control
            type="text"
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            placeholder="Enter Target"
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button
          onClick={updateStudyCDISCCMap}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateCMapMetadata;
